export default __webpack_public_path__ + "static/susanArticle-d9cf331e671ce47e09ccbff3992bf953.jpg";